import type { ICouponRepository, IGetCouponWalletsUseCase } from '../../../domain/entry.js';

/**
 * Use case for getting the wallets of a coupon by couponId.
 *
 * @param couponRepository Coupon repository dependency
 * @returns Use case executor for retrieving a coupon's wallets
 */
export function getCouponWalletsUseCase(couponRepository: ICouponRepository): IGetCouponWalletsUseCase {
  return {
    execute: ({ couponId }): ReturnType<IGetCouponWalletsUseCase['execute']> => {
      return couponRepository.getCouponWallets({ couponId });
    },
  };
}
